export const handleName=(type)=>{
    let selectedType = '';
    switch (type) {
    case 'classes':
        selectedType = `Class`     
        break;
    case 'sections':
        selectedType = 'Section'
        break;
    case 'subjects':
        selectedType = 'Subject'    
        break;
    case 'fee head':
        selectedType = 'Fee Head'     
        break;
    case 'exam':
        selectedType =  'Exam'    
        break;
    default:
        break;
    }
    return selectedType
}

export const handleEndpoint=(type)=>{
    if(type==='exam'){
        return 'exams'
    }
    return type.replace(/\s/g,'')
}
export const handleNavigation=(type)=>{
    let url = ''
    switch (type) {
    case 'classes':
        url = `/main-hub/classes/add-class`     
        break;
    case 'sections':
        url = '/main-hub/manage-sections/add-section'
        break;
    case 'subjects':
        url = '/main-hub/subjects/add-subjects'    
        break;
    case 'fee head':
        url = '/fee-management/fee-head/add-fee-head'     
        break;
    case 'exam':
        url =  '/student-master/exam/add-exam'    
        break;
    default:
        break;
    }
    return url

}